import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LoginService } from '../login.service';

@Component({
  selector: 'qst-leader-board',
  templateUrl: './leader-board.component.html',
  styleUrls: ['./leader-board.component.scss']
})
export class LeaderBoardComponent implements OnInit {

  teams: Team[];

  constructor(private http: HttpClient,
              private loginService: LoginService ) { }

  ngOnInit(): void {
    var eventId: number = this.loginService.getEventId();

    this.http.get("http://herenow.live/service.php?action=leaderBoard&eid=" + eventId).subscribe((responseBody) => {
      this.teams = <Team[]>responseBody;
      console.log("LeaderBoard.ngOnInit()");
      console.log(this.teams);
    });
/*
    this.teams = [
      {
        "name": "test",
        "score": 500
      }
    ];
*/
  }

}

export interface Team {
  name: string;
  total: number;
}
